import { ReactNode } from "react";
import { Typography } from "@mui/material";
import { OptionButton } from "shared/components/Inputs/OptionButton";
import { QuestionLayouts } from "modules/MainSurveyEditor/helpers/blockForm";

const LayoutOptions: LayoutOption[] = [
  {
    value: QuestionLayouts.Vertical,
    name: "Vertical",
  },
  {
    value: QuestionLayouts.Horizontal,
    name: "Horizontal",
  },
];

export const QuestionLayoutField = (props: QuestionLayoutFieldProps) => {
  const { onChange, selectedValue = QuestionLayouts.Vertical } = props;

  return (
    <div className="module-question-layout-field">
      {LayoutOptions.map(({ value, icon, name }) => (
        <OptionButton
          key={value}
          content={
            <div className="_d-flex-dir-col-ali-center-md-gap">
              <Typography>{name}</Typography>
            </div>
          }
          value={value}
          selectedValue={selectedValue}
          onClick={() => onChange(value)}
        />
      ))}
    </div>
  );
};

interface QuestionLayoutFieldProps {
  onChange: (value: string) => void;
  selectedValue?: string;
}

type LayoutOption = {
  value: string;
  icon?: ReactNode;
  name: string;
};
